<template>
  <div class="page-content">
    <div class="page-title">Rights and Duties of Members</div>
    <div class="text">
      (1) <b>Full members </b>up to date with their membership dues shall have the right to vote and
      to stand for election, and shall have full powers of participation, proposal and execution.
      They shall pay an annual membership fee, whose payment is due on 1st January of each year, and
      whose amount shall be fixed by the World Congress.
      <br />
      <br />
      (2) <b>Associate members</b> shall receive all information and documentation printed by the
      World Federation, and have the right to take part in its programmes. They have a consultative
      voice. They shall make a financial contribution, whose amount shall be fixed by the Executive
      Board, in payment for the services rendered.
      <br />
      <br />
      (3) <b>Honorary members</b> and <b>Advisors</b> shall receive information diffused by the
      World Federation. They are not held to the payment of a certain contribution and they can make
      a voluntary contribution. They have a consultative voice during the sessions of the Executive
      Boards and the World Congress.
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
